var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftnav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33284 11.0635L12.0131 0.383412C12.2602 0.136194 12.5899 0 12.9415 0C13.2931 0 13.6229 0.136194 13.8699 0.383412L14.6564 1.16975C15.1682 1.68213 15.1682 2.51491 14.6564 3.02651L5.68793 11.995L14.6664 20.9735C14.9134 21.2207 15.0498 21.5503 15.0498 21.9017C15.0498 22.2535 14.9134 22.583 14.6664 22.8305L13.8799 23.6166C13.6326 23.8638 13.3031 24 12.9515 24C12.5999 24 12.2701 23.8638 12.0231 23.6166L1.33284 12.9267C1.08523 12.6787 0.949236 12.3476 0.950017 11.9956C0.949236 11.6422 1.08523 11.3113 1.33284 11.0635Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftnav);
export default __webpack_public_path__ + "static/media/leftnav.9226ece4e3a1315aa31534d0f8105d9b.svg";
export { ForwardRef as ReactComponent };